import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

const SectionLoaderStyles = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

const SectionLoader = ({ children, isLoading }) => (
  <>
    {isLoading && (
      <SectionLoaderStyles>
        <Loader
          type="TailSpin"
          color={themeColors.colorSvgSemidark}
          height={300}
          width={300}
        />
      </SectionLoaderStyles>
    )}

    {children}
  </>
);

SectionLoader.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

export default SectionLoader;
